export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana15.cf5241ee.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};